import moment from 'moment';
export default {
	resultList: [],
	occuPlList: [],
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		strDt: moment().subtract(1, 'month').format('YYYYMMDD'),
		endDt: moment().format('YYYYMMDD'),
		partNo: '',
		occuPlCd: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
